import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneImplementationStagesAndActivities = createAsyncThunk(
  "dropdowns/GetOneImplementationStagesAndActivities",
  async (Parameter, { rejectWithValue }) => {
    console.log("sdsdssaccascdsdsdsd");
    
    try {
      
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_DirectCosts/GetOneImplementationStagesAndActivities",Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ImplementationStagesAndActivitiesReducers = createSlice({
  name: "TypeOfJobOpportunityDropDown",
  initialState: {
    ImplementationStagesAndActivities: [],
    loadingImplementationStagesAndActivities: false,
    errorImplementationStagesAndActivities: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOneImplementationStagesAndActivities.pending, (state, action) => {
        state.loadingImplementationStagesAndActivities = true;
        state.ImplementationStagesAndActivities = action.payload;
        state.errorImplementationStagesAndActivities = null;
      })
      .addCase(GetOneImplementationStagesAndActivities.fulfilled, (state, action) => {
        state.loadingImplementationStagesAndActivities = false;
        state.ImplementationStagesAndActivities = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetOneImplementationStagesAndActivities.rejected, (state, action) => {
        state.loadingImplementationStagesAndActivities = false;
        state.errorImplementationStagesAndActivities = action.payload;
      });
  },
});

export default ImplementationStagesAndActivitiesReducers.reducer;
